export enum TaskType {
  epic = 'epic',
  story = 'story',
  feature = 'feature',
  improvement = 'improvement',
  experiment = 'experiment',
  task = 'task',
  bug = 'bug',
  idea = 'idea',
}

export const TaskTypeArray: TaskType[] = Object.values(TaskType);

/**
 * Single source of truth for the order task types are displayed in — used by
 * both the property/type dropdown and the filter panel so the two can never
 * drift apart (#2443). A unit test asserts this stays a complete permutation of
 * the TaskType enum, so adding a new type can't silently drop it from either UI.
 */
export const TASK_TYPE_ORDER: TaskType[] = [
  TaskType.epic,
  TaskType.story,
  TaskType.feature,
  TaskType.improvement,
  TaskType.experiment,
  TaskType.task,
  TaskType.bug,
  TaskType.idea,
];

export const TaskTypeUtils = {
  getTitle(taskType: TaskType): string {
    return taskType.charAt(0).toUpperCase() + taskType.slice(1);
  },
};
